import { ItemList } from "../orm";

class FacialRecognitionList extends ItemList {
  getEntityKey() {
    return "photographer/gallery/index_gallery_for_facial_recognition";
  }

  indexGalleryForFacialRecognition(galleryId) {
    return (dispatch, getState) => {
      dispatch(this.clearListFilter());
      dispatch(
        this.updateListFilter({
          gallery_id: galleryId,
        }),
      );
      dispatch(this.fetchListIfNeeded());
    };
  }
}

export const facialRecognitionList = new FacialRecognitionList(
  "facial_recognition__default",
);
